import React, { Component } from 'react';
import './index.less';

class Header extends Component {

    handleClick = () => {
        window._MEIQIA('showPanel');
    }
    render() {
        const me = this;
        return (
            <div className="banner">
                <div className="banner__wrapper">
                    <div className="banner__wrapper-btn" onClick={me.handleClick}></div>
                </div>
            </div>
        );
    }
}

export default Header;